import produce from 'immer';
import { size } from 'lodash/fp';
import * as actions from './actions';

export const initialState = {
  creationTask: { data: null, loading: false, error: null },
  count: {
    data: {
      total: 0, success: 0, failure: 0, completed: null,
    },
    loading: false,
    error: null,
  },
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
    case actions.CREATE_CONTACT_REQUEST:
      draft.creationTask.loading = true;
      break;
    case actions.CREATE_CONTACT_SUCCESS:
      draft.creationTask.loading = false;
      draft.creationTask.data = true;
      break;
    case actions.CREATE_CONTACT_FAILURE:
      draft.creationTask.loading = false;
      draft.creationTask.error = action.payload.error;
      break;
    case actions.CREATE_CONTACTS_REQUEST:
      draft.count.loading = true;
      draft.count.data.total = size(action.payload.contacts);
      break;
    case actions.CREATE_CONTACTS_SUCCESS:
      draft.count.loading = false;
      draft.count.data.completed = true;
      break;
    case actions.CREATE_CONTACTS_FAILURE:
      draft.count.loading = false;
      draft.count.data.completed = false;
      draft.count.error = action.payload.error;
      break;
    case actions.CREATE_CONTACTS_SUBTASK_SUCCESS:
      draft.count.data.success += 1;
      break;
    case actions.CREATE_CONTACTS_SUBTASK_FAILURE:
      draft.count.data.failure += 1;
      break;
    case actions.INIT_CREATION_TASK:
      draft.creationTask = { data: false, loading: false, error: null };
      break;
    case actions.INIT_COUNT:
      draft.count = { data: { success: 0, failure: 0, completed: null }, loading: false, error: null };
      break;
    default:
  }
});

export default reducer;
